import React from 'react';
import { useAuth } from './auth/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Avatar, CircularProgress, Box } from '@mui/material';
import SVGComponentLight from './screens/svgviewer-react-output-remaster.js';

export default function Header() {
    const { currentUser, dbUser } = useAuth();
    const navigate = useNavigate();

    const avatarSrc = dbUser?.profilePicture
        ? `https://bluejims.com:5005/misbolos/image/${dbUser.profilePicture}/q/1`
        : currentUser?.photoURL || 'https://bluejims.com:5005/misbolos/image/686307214b7f704168701a84';

    const hasPendingNotifications = dbUser?.notifications?.some(n => n.status === 'pending');

    return (
        <AppBar position="sticky" sx={{ backgroundColor: 'black', minHeight: '8vh' }}>
            <Toolbar>
                <Typography
                    variant="h6"
                    sx={{
                        flexGrow: 1,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        padding: '1px',
                        cursor: 'pointer',
                    }}
                    onClick={() => navigate('/oficiomania/')}
                >
                    <SVGComponentLight style={{ marginRight: 12, width: '44px', height: '44px' }} />
                    OficioMania
                </Typography>

                {currentUser ? (
                    avatarSrc ? (
                        <Box sx={{ position: 'relative' }}>
                            <Avatar
                                src={avatarSrc}
                                alt={currentUser.displayName || 'User'}
                                sx={{
                                    cursor: 'pointer',
                                    border: '2px solid white',
                                    boxShadow: '0 0 4px rgba(255, 255, 255, 0.6)',
                                }}
                                onClick={() => navigate('/oficiomania/login')}
                            />
                            {hasPendingNotifications && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        width: 12,
                                        height: 12,
                                        backgroundColor: 'red',
                                        borderRadius: '50%',
                                        border: '2px solid white',
                                    }}
                                />
                            )}
                        </Box>
                    ) : (
                        <CircularProgress size={24} color="inherit" />
                    )
                ) : (
                    <Button color="inherit" onClick={() => navigate('/oficiomania/login')}>
                        Acceder
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    );
}
